<template lang="pug">
  v-card.ma-1
    v-card-title.primary 計算明細
    v-card-text.pa-1
      v-layout(row wrap)
        v-flex(xs12 md3)
          v-card
            v-card-title.grey
              span 寸法
            v-card-text
              .app-lines-header
                span 内寸
              .app-line
                span.app-line-title 幅
                span.app-line-text {{box.inner.width}}
                span.app-line-suffix mm
              .app-line
                span.app-line-title 高さ
                span.app-line-text {{box.inner.height}}
                span.app-line-suffix mm
              .app-line
                span.app-line-title 奥行
                span.app-line-text {{box.inner.depth}}
                span.app-line-suffix mm
              .app-lines-header
                span 外寸
              .app-line
                span.app-line-title 幅
                span.app-line-text {{box.outer.width}}
                span.app-line-suffix mm
              .app-line
                span.app-line-title 高さ
                span.app-line-text {{box.outer.height}}
                span.app-line-suffix mm
              .app-line
                span.app-line-title 奥行
                span.app-line-text {{box.outer.depth}}
                span.app-line-suffix mm
              v-alert(type="info" value="true" v-if="box.m3.extended")
                span 継ぎ足し加工あり
              v-alert(type="warning" value="true" v-if="box.m3.twoway_extended")
                span 継ぎ足し加工が二方向に渡っています。強度に問題が出る可能性があります。
        v-flex(xs12 md5)
          v-card
            v-card-title.grey
              span 面別
            v-card-text
              div(v-for="(face, faceIndex) in box.order_faces" :key="faceIndex")
                .app-lines-header
                  v-layout(row wrap)
                    v-flex.pa-0(xs6)
                      span {{face.code}}:{{face.name}}
                    v-flex.pa-0(xs6)
                      v-spacer
                      .app-line
                        span.app-line-title
                        span.app-line-text {{face.amount|number(2)}}
                        span.app-line-suffix 円
                div(v-for="(board, boardIndex) in face.order_boards" :key="boardIndex")
                  .app-line
                    span.app-line-title
                      span {{board.code}}
                      span(v-if="board.name") :{{board.name}}
                      span W:{{board.x}} x H:{{board.y}} x D:{{board.osb.thick}} x {{board.quantity}}
                    span.app-line-text {{board.amount|number(2)}}
                    span.app-line-suffix 円
        v-flex(xs12 md4)
          v-card
            v-card-title.grey
              span 項目別
            v-card-text
              .app-lines-header
                v-layout(row wrap)
                  v-flex.pa-0(xs6)
                    span クランプ
                    span.remarks (箱あたり)
                  v-flex.pa-0(xs6)
                    v-spacer
                    .app-line
                      span.app-line-title
                      span.app-line-text {{box.order_clamp.amount|number(2)}}
                      span.app-line-suffix 円
              .app-line
                span.app-line-title 単価
                span.app-line-text {{box.order_clamp.unit_cost|number(2)}}
                span.app-line-suffix 円
              .app-line
                span.app-line-title 個数
                span.app-line-text {{box.order_clamp.quantity}}
                span.app-line-suffix 個
              .app-line
                span.app-line-title 必要数
                span.app-line-text {{box.order_clamp.clamp_pcs}}
                span.app-line-suffix 個
              p.text-xs-right.remarks
                | 天板・側板
                | {{box.clamps.top_side}}
                | 個
              p.text-xs-right.remarks
                | 側板・側板
                | {{box.clamps.side_side}}
                | 個
              p.text-xs-right.remarks
                | 底板・側板
                | {{box.clamps.bottom_side}}
                | 個
              .app-line
                span.app-line-title 予備
                span.app-line-text {{box.order_clamp.clamp_spare_pcs}}
                span.app-line-suffix 個
              .app-line
                span.app-line-title 三方向平均ピッチ
                span.app-line-text {{box.order_clamp.average_pitch}}
                span.app-line-suffix mm
              div(v-if="box.order_clog.clog.calculate")
                .app-lines-header
                  v-layout(row wrap)
                    v-flex.pa-0(xs6)
                      span 桁
                      span.remarks (箱あたり)
                    v-flex.pa-0(xs6)
                      v-spacer
                      .app-line
                        span.app-line-title
                        span.app-line-text {{box.order_clog.amount|number(2)}}
                        span.app-line-suffix 円
                .app-line
                  span.app-line-title 長さ
                  span.app-line-text {{box.order_clog.length}}
                  span.app-line-suffix mm
                .app-line
                  span.app-line-title 単価
                  span.app-line-text {{box.order_clog.unit_cost|number(2)}}
                  span.app-line-suffix 円/m
                .app-line
                  span.app-line-title 原価
                  span.app-line-text {{box.order_clog.cost_per_clog|number(2)}}
                  span.app-line-suffix 円/m
                .app-line
                  span.app-line-title 本数
                  span.app-line-text {{box.order_clog.quantity}}
                  span.app-line-suffix 本
                .app-line
                  span.app-line-title 重量
                  span.app-line-text {{box.order_clog.weight_total|number(2)}}
                  span.app-line-suffix kg
              div(v-if="box.order_buckle.buckle.calculate")
                .app-lines-header
                  v-layout
                    v-flex.pa-0(xs6)
                      span バックル/ベルト
                      span.remarks (箱あたり)
                    v-flex.pa-0(xs6)
                      v-spacer
                      .app-line
                        span.app-line-title
                        span.app-line-text {{box.order_buckle.amount|number(2)}}
                        span.app-line-suffix 円
                .app-line
                  span.app-line-title 種類
                  span.app-line-text {{box.order_buckle.buckle.name}}
                  span.app-line-suffix
                .app-line
                  span.app-line-title
                    span バックル
                    span {{box.order_buckle.buckle_unit_cost}}円 x {{box.order_buckle.quantity}}個
                  span.app-line-text {{box.order_buckle.buckle_amount}}
                  span.app-line-suffix 円
                .app-line
                  span.app-line-title
                    span ベルト
                    span
                      | {{box.order_buckle.belt_unit_cost}}円/m x {{box.order_buckle.length}}m x {{box.order_buckle.quantity}}本
                  span.app-line-text {{box.order_buckle.belt_amount}}
                  span.app-line-suffix 円
              div(v-for="stamp in box.order_stamps" :key="stamp.id")
                .app-lines-header
                  v-layout
                    v-flex.pa-0(xs6)
                      span スタンプ
                      span.remarks (箱あたり)
                    v-flex.pa-0(xs6)
                      v-spacer
                      .app-line
                        span.app-line-title
                        span.app-line-text {{stamp.amount|number(2)}}
                        span.app-line-suffix 円
                .app-line
                  span.app-line-title 種類
                  span.app-line-text {{stamp.stamp.name}}
                  span.app-line-suffix
                .app-line
                  span.app-line-title 単価
                  span.app-line-text {{stamp.unit_cost}}
                  span.app-line-suffix 円

      v-divider.my-2

      v-layout(row wrap)
        v-flex(xs12 md4 v-for="(face, faceIndex) in box.order_faces" :key="faceIndex")
          v-card
            v-card-title.grey
              span {{face.code}}:{{face.name}}
            v-card-text
              div(v-for="(board, boardIndex) in face.order_boards" :key="boardIndex")
                .app-lines-header
                  span {{board.code}}
                  span(v-if="board.name") :{{board.name}}
                .app-line
                  span.app-line-title 横
                  span.app-line-text {{board.x}}
                  span.app-line-suffix mm
                .app-line
                  span.app-line-title 縦
                  span.app-line-text {{board.y}}
                  span.app-line-suffix mm
                .app-line
                  span.app-line-title 板厚
                  span.app-line-text {{board.osb.thick}}
                  span.app-line-suffix mm
                .app-line
                  span.app-line-title 枚数
                  span.app-line-text {{board.quantity}}
                  span.app-line-suffix 枚
                .app-line
                  span.app-line-title 面積
                  span.app-line-text {{board.square|number(4)}}
                  span.app-line-suffix
                    | m
                    sup 2
                .app-line
                  span.app-line-title
                    | m
                    sup 2
                    | 単価
                  span.app-line-text {{board.unit_cost|number(2)}}
                  span.app-line-suffix
                    | 円/m
                    sup 2
                .app-line
                  span.app-line-title 原価
                  span.app-line-text {{board.amount|number(2)}}
                  span.app-line-suffix 円
                .app-line
                  span.app-line-title エッジ加工(上)
                  span.app-line-text No.{{board.top_edge.program_no}} : {{board.top_edge.description}}
                  span.app-line-suffix
                .app-line
                  span.app-line-title エッジ加工(右)
                  span.app-line-text No.{{board.right_edge.program_no}} : {{board.right_edge.description}}
                  span.app-line-suffix
                .app-line
                  span.app-line-title エッジ加工(下)
                  span.app-line-text No.{{board.bottom_edge.program_no}} : {{board.bottom_edge.description}}
                  span.app-line-suffix
                .app-line
                  span.app-line-title エッジ加工(左)
                  span.app-line-text No.{{board.left_edge.program_no}} : {{board.left_edge.description}}
                  span.app-line-suffix
</template>

<script>
export default {
  props: ['box']
}
</script>

<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/app/pages/Order/Components/BoxDetail.vue